import { render, staticRenderFns } from "./veSbzcJzwInfo.vue?vue&type=template&id=016624cd&scoped=true"
import script from "./veSbzcJzwInfo.vue?vue&type=script&lang=js"
export * from "./veSbzcJzwInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016624cd",
  null
  
)

export default component.exports